/**
 * @flow
 */

const styles = {
  dropdownStyles: {
    padding: 0
  }
}

export default styles



// WEBPACK FOOTER //
// ./src/components/IbcArcade/FormDropdown/styles.js